import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';

import { getAppUrlImg } from '../../../helper/Url';

class Button extends AbstractComponent {   
    background() {
        return this.props.background === 1   
            ? "btn btn--default btn--size-m "
            : "btn btn--link btn--size-m " + (this.props.color ? '' : 'btn--gray');// + " area-cart-item__button";
    } 

    background2() {
        switch(this.props.background) {
            case 1: 
                return 'btn__label';
            case 2:  
                return 'btn__label-light';
            case 3:
                return '';
            default:
                return 'btn__label';
        }        
    }

    onClick(e) {
        if(this.props.onClick !== undefined)
            this.props.onClick(e);
    }

    showComponent() {
        if(!this.props.visible)
            return;
            
        return (
            <button 
                type={this.props.type}
                className={this.background() + ' ' + this.props.className + ' ' + (this.props.preload ? 'btn--preload' : '')}                
                disabled={this.props.disabled}
                style={this.props.style}
                onClick={(e) => this.onClick(e)}
            >                
                <div 
                    className={this.background2() + ' ' + (this.props.preload ? 'display-none' : '')}
                    style={{
                        justifyContent: this.props.justifyContent,
                        display: this.props.display
                    }}
                >
                    <span>
                        {this.props.children}
                    </span>

                    {
                        this.props.label &&
                        <span>
                            &nbsp;
                            {this.props.label}
                        </span>
                    }                    
                </div>  

                <div className={"product-action__add-button " + (this.props.preload ? '' : 'display-none')}>
                    <img src={getAppUrlImg() + "preload_botao.gif"} style={{width: '25px', height: '25px', marginTop: '-8px'}} alt="Loading..."/> <br/>
                </div>
            </button> 
        );
    }

    render() {
        return (                
            <Fragment>
                {this.showComponent()}
            </Fragment>              
        )
    }
}

Button.defaultProps = {
    className: '',
    background: 1,
    color: true,    
    justifyContent: 'space-between',    
    visible: true
}

export default Button;